import {alias, createModelSchema, custom, deserialize, primitive, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";


export class SmartOfferSkin extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(SmartOfferSkin, v) : SKIP;
            },
            (v) => {
                return deserialize(SmartOfferSkin, v);
            }
        );
    }


    constructor() {
        super();

        this._key = null;
        this._path = null;

        this._started = 0;
        this._duration = 0;

        this._default = false;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get path() {
        return this._path;
    }

    set path(value) {
        this._path = value;
    }

    get started() {
        return this._started;
    }

    set started(value) {
        this._started = value;
    }

    get duration() {
        return this._duration;
    }

    set duration(value) {
        this._duration = value;
    }

    get default() {
        return this._default;
    }

    set default(value) {
        this._default = value;
    }

    valid() {

        if (!this.key || this.key.length === 0) {
            return false;
        }

        if(!Number.isInteger(this.started)){
            return false;
        }

        if(!Number.isInteger(this.duration)){
            return false;
        }

        if(!this.default) {

            if (this.started <= 0 ) {
                return false;
            }

            if (this.duration <= 0) {
                return false;
            }
        }

        return true;
    }

    empty() {
        return !this.key || this.key.length === 0;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferSkin());
        } else if (target instanceof SmartOfferSkin) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }

}

createModelSchema(SmartOfferSkin, {
    _key: alias("key", Schema.primitive()),
    _path: alias("path", Schema.primitive()),
    _started: alias("started", Schema.primitive()),
    _duration: alias("duration", Schema.primitive()),
    _default: alias("default", primitive()),
});